
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.857","height":"6"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(9442 19029)","fill":"#12b6d4"}},[_c('circle',{attrs:{"data-name":"楕円形 96","cx":"3","cy":"3","r":"3","transform":"translate(-9442 -19029)"}}),_c('circle',{attrs:{"data-name":"楕円形 97","cx":"3","cy":"3","r":"3","transform":"translate(-9432.571 -19029)"}}),_c('circle',{attrs:{"data-name":"楕円形 98","cx":"3","cy":"3","r":"3","transform":"translate(-9423.143 -19029)"}})])])
          )
        }
      }
    